import { CivilityTypeValues } from '../../models/customer';

export const CivilityList = [
    { key: '0', value: CivilityTypeValues.MR, text: 'Monsieur' },
    { key: '1', value: CivilityTypeValues.MRS, text: 'Madame' },
];
